export default __webpack_public_path__ + "static/media/kiosk-trans-new-booking-system-ss.7ab4c82d.png";